/* eslint-disable */
'use strict';

const Account = {
    init: function() {
        this.handleAddAddressButtons();
        this.handleEdittingAddress();
        this.handleGettingProvincesPerCountry();
        this.handleMenuNavigation();
        this.handleDropDowns();
    },

    handleDropDowns: ()=> {
        var dropdown = document.querySelector('.dropdown-el');
        if(dropdown) {
            dropdown.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                this.classList.toggle('expanded');
                if (e.target.tagName.toLowerCase() === 'a' && e.target.href !== '') {
                    window.location.href = e.target.href;
                }
            });

            document.addEventListener('click', function() {
                dropdown.classList.remove('expanded');
            });
        }
    },

    handleGettingProvincesPerCountry: ()=> {
        Shopify.countryProvinceSelector = function(countryDropdownId, provinceDropdownId, options) {
            this.countryDropdown = document.getElementById(countryDropdownId);
            this.provinceDropdown = document.getElementById(provinceDropdownId);
            this.config = options || {};
        
            this.init = function() {
                if (this.countryDropdown && this.provinceDropdown) {
                    this.countryDropdown.addEventListener('change', this.updateProvinceDropdown.bind(this));
                    this.updateProvinceDropdown();
                }
            };
        
            this.updateProvinceDropdown = function() {
                var selectedCountry = this.countryDropdown.value;
                var provinces = this.getProvinces(selectedCountry);
                this.populateProvinces(provinces);
            };
        
            this.getProvinces = function(country) {
                var selectedOption = this.countryDropdown.options[this.countryDropdown.selectedIndex];
                var provincesString = selectedOption.getAttribute('data-provinces') || '';
                var provincesArray = JSON.parse(provincesString);
                return provincesArray.map(function(provincePair) {
                    return provincePair[1];
                });
            };
        
            this.populateProvinces = function(provinces) {
                this.provinceDropdown.innerHTML = '';
                provinces.forEach(function(province) {
                    var option = document.createElement('option');
                    option.value = province;
                    option.textContent = province;
                    this.provinceDropdown.appendChild(option);
                }.bind(this));
            };
            
            this.init();
        };

        let editAddressForms = document.querySelectorAll('.edit-address-container');

        editAddressForms.forEach(container => {
            let countryElement = container.querySelector('[id^="AddressCountryEdit-"]');
            let provinceElement = container.querySelector('[id^="AddressProvinceEdit-"]');
            
            new Shopify.countryProvinceSelector(countryElement.id, provinceElement.id);
        });

        new Shopify.countryProvinceSelector('AddressCountryNew', 'AddressProvinceNew');
    },

    handleMenuNavigation: ()=> {
        var dropdown = document.getElementById("navigationDropdown");
        if(dropdown){
            dropdown.addEventListener('change', ()=>{
                var selectedUrl = dropdown.options[dropdown.selectedIndex].value;
                if (selectedUrl) {
                    window.location.href = selectedUrl;
                }
            })
        }
    },

    handleAddAddressButtons: ()=>{
        var addButton = document.getElementById('add-address-btn');
        var cancelButton = document.getElementById('add-address-cancel');

        if(cancelButton) {
            cancelButton.addEventListener('click', function() {
                let addAddressForm = document.getElementById('AddAddress');
                if(addAddressForm){
                    addAddressForm.style.display = 'none';
                    addButton.style.display = 'flex';
                }
            });
        }
        if(addButton) {
            addButton.addEventListener('click', function() {
                let addAddressForm = document.getElementById('AddAddress');
                if(addAddressForm){
                    addButton.style.display = 'none';
                    addAddressForm.style.display = 'block';
                }
            });
        }
    },

    handleEdittingAddress: ()=>{
         // Function to handle cancel button click
        document.querySelectorAll('.cancel-btn').forEach(button => {
            if(button) {
                button.addEventListener('click', function() {
                    // Find the closest parent div with class edit-address-container and hide it
                    this.closest('.edit-address-container').style.display = 'none';
                    
                    const address = this.getAttribute('data-toggle'); 
                    if(address) {
                        document.querySelectorAll('.customer-address__address-container[data-toggle="' + address + '"]').forEach(container => {
                            if(container) {
                                container.style.display = 'flex';    
                            }                            
                        });   
                    }                    
                });
            }
        });

        // Function to handle edit address button click
        document.querySelectorAll('.edit-address-btn').forEach(button => {
            if(button) { 
                button.addEventListener('click', function() {     
                    const address = this.getAttribute('data-address');
                    if(address) {      
                        // Find all edit address containers with the matching data-address attribute and display them
                        document.querySelectorAll('.edit-address-container[data-address="' + address + '"]').forEach(container => {
                            if(container) {
                                container.style.display = 'block';
                                const firstParent = button.parentNode;
                                if(firstParent) {
                                    const secondParent = firstParent.parentNode;
                                    if(secondParent) {
                                        secondParent.style.display = 'none';
                                    }                                
                                }
                            }
                        });
                    }
                });
            }
        });
    }
}; 

export default Account;
